import { voucherTypeVariant } from "../../../helpers/conts"


const VoucherTypeCell = ({ type }) => <span className={"text-capitalize badge badge-" + voucherTypeVariant[type]}>{type}</span>

export default VoucherTypeCell